import { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { Menu, X, Cpu } from 'lucide-react';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);

  const navLinkClasses = ({ isActive }: { isActive: boolean }) =>
    `font-medium transition-colors duration-200 ${isActive
      ? 'text-primary'
      : 'text-gray-700 hover:text-primary'
    }`;

  return (
    <header className={`sticky top-0 z-50 transition-all duration-300 ${isScrolled
        ? 'bg-white shadow-md py-3'
        : 'bg-transparent py-5'
      }`}>
      <div className="container-custom">
        <nav className="flex justify-between items-center">
          {/* Logo */}
          <NavLink to="/" className="flex items-center space-x-2 text-primary">
            <Cpu className="h-8 w-8" />
            <span className="font-heading text-xl font-bold">UPNOV IA</span>
          </NavLink>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <NavLink to="/" className={navLinkClasses}>Accueil</NavLink>
            <NavLink to="/formation-ia-entreprise/" className={navLinkClasses}>Formations</NavLink>
            <NavLink to="/accompagnement-ia-entreprise/" className={navLinkClasses}>Services IA</NavLink>
            <NavLink to="/about/" className={navLinkClasses}>À propos</NavLink>
            <NavLink to="/blog/" className={navLinkClasses}>Blog</NavLink>
            <NavLink to="/contact/" className={navLinkClasses}>Contact</NavLink>
            <NavLink to="/demarrer-votre-diagnostic-ia-entreprise/" className="btn-secondary whitespace-nowrap">
              Diagnostic gratuit
            </NavLink>
            <NavLink to="/DemandeInfo/" className="btn-primary whitespace-nowrap">
              Demander un devis
            </NavLink>
          </div>

          {/* Mobile Navigation Button */}
          <button
            className="md:hidden p-2 focus:outline-none"
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </nav>

        {/* Mobile Navigation Menu */}
        {isMenuOpen && (
          <div className="md:hidden bg-white absolute left-0 right-0 top-full shadow-md animate-slide-down">
            <div className="flex flex-col space-y-4 p-6">
              <NavLink to="/" className={navLinkClasses} onClick={closeMenu}>Accueil</NavLink>
              <NavLink to="/formation-ia-entreprise/" className={navLinkClasses} onClick={closeMenu}>Formations</NavLink>
              <NavLink to="/accompagnement-ia-entreprise/" className={navLinkClasses} onClick={closeMenu}>Services IA</NavLink>
              <NavLink to="/about/" className={navLinkClasses} onClick={closeMenu}>À propos</NavLink>
              <NavLink to="/blog/" className={navLinkClasses} onClick={closeMenu}>Blog</NavLink>
              <NavLink to="/contact/" className={navLinkClasses} onClick={closeMenu}>Contact</NavLink>
              <NavLink to="/demarrer-votre-diagnostic-ia-entreprise/" className="btn-secondary text-center" onClick={closeMenu}>
                Diagnostic gratuit
              </NavLink>
              <NavLink to="/DemandeInfo/" className="btn-primary text-center" onClick={closeMenu}>
                Demander un devis
              </NavLink>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Navbar;